import React, { Component } from 'react'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import styles from '../style.module.less'
import cls from 'classnames'
import Form from './Form'
import FormSiYi from './FormSiYi'
import Store from './Form/store'
import StoreSiYi from './FormSiYi/store'
import { Link } from 'react-router'
import { isSiYiTeam } from '@util'
import SimpleGuide from '@common/SimpleGuide'
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: { query }
    } = this.props
    isSiYiTeam()
      ? (this.store = new StoreSiYi(query))
      : (this.store = new Store(query))
  }
  componentDidMount() {
    if (!isSiYiTeam()) {
      this.store.getStoreType()
      this.store.getCountry()
    }
  }
  render() {
    const { loading } = this.store
    const GUIDE_TASK_ID = 34
    return (
      <div
        className={cls({
          [styles.edit]: true,
          [styles.register_edit]: true
        })}
      >
        {isSiYiTeam() ? (
          <>
            <FormSiYi store={this.store} />
            <SimpleGuide guideId={GUIDE_TASK_ID} />
          </>
        ) : (
          <Form store={this.store} />
        )}

        <div className={styles.center}>
          <Link
            to={
              isSiYiTeam()
                ? '/localMerchant/siYiTeamGroupMember'
                : '/localMerchant/groupMember'
            }
          >
            <Button className={styles.save} style={{ marginRight: 20 }}>
              取消
            </Button>
          </Link>
          <Button
            type="primary"
            onClick={this.store.updateStoreInfo}
            className={styles.save}
            loading={loading}
          >
            确定
          </Button>
        </div>
      </div>
    )
  }
}
